/*
 *
 * ShelvesRibbon actions
 *
 */

import { action } from 'typesafe-actions';
import ActionTypes from 'containers/Ribbon/ShelvesRibbon/constants';
import { Position, PositionAngle } from 'lib/modelBuilder/constants';
import { ShelfSelection } from 'lib/modelBuilder/entities/ShelfSelection';

export const shelvesSelectionMenuAction = (menuOpen: boolean) =>
  action(ActionTypes.SHELVES_SELECTION_MENU, { menuOpen: menuOpen });

export const updateProfileSelectionAction = (
  shelfSelectionProfile: ShelfSelection,
) => action(ActionTypes.UPDATE_PROFILE_SELECTION, { shelfSelectionProfile });

export const selectAllPiecesAction = () =>
  action(ActionTypes.SELECT_ALL_PIECES);
export const selectAllDoorsAction = () => action(ActionTypes.SELECT_ALL_DOORS);
export const selectAllSidesAction = () => action(ActionTypes.SELECT_ALL_SIDES);

export const selectDoorsAction = (positions: PositionAngle[]) =>
  action(ActionTypes.DOORS_SELECTION, { positions });

export const toggleSelectionDoorAction = (
  position: PositionAngle,
  multi = false,
) => action(ActionTypes.TOGGLE_DOOR_SELECTION, { position, multi });

export const selectPanesAction = (positions: Position[]) =>
  action(ActionTypes.PANES_SELECTION, { positions });

export const toggleSelectionPaneAction = (position: Position, multi = false) =>
  action(ActionTypes.TOGGLE_PANE_SELECTION, { position, multi });

export const deleteSelectionAction = () => action(ActionTypes.DELETE_SELECTION);
